// extracted by mini-css-extract-plugin
export default {"table":"Detail_table__ZalFl","tdFirst":"Detail_tdFirst__t8vxP"};